import React from "react";
import "./Refund.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet-async";
function Refund() {
  return (
    <>
    
<Helmet>
  <title>Refund & Return Policy | Astro Logical Solutions</title>

  <meta
    name="description"
    content="Understand the refund, return, replacement and cancellation process for eligible purchases from Astro Logical Solutions."
  />

  <link
    rel="canonical"
    href="https://astrologicalsolutions.in/refund-Policy"
  />

  <meta
    name="robots"
    content="index, follow, max-image-preview:large"
  />

  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Refund & Return Policy | Astro Logical Solutions"
  />
  <meta
    property="og:description"
    content="Learn about refund requests, returns, replacements and cancellations at Astro Logical Solutions."
  />
  <meta
    property="og:url"
    content="https://astrologicalsolutions.in/refund-Policy"
  />
  <meta
    property="og:site_name"
    content="Astro Logical Solutions"
  />
</Helmet>

      <Header />
      <div className="shipping-page">
        <section className="shipping-hero">
          <h1 className="page-title">
            Refund Policy - Astro Logical Solutions
            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          </h1>
          <div className="hero-card">
            <span className="hero-badge">REFUND &amp; POLICY </span>
            <h2>Our Fair & Transparent Refund Policy</h2>
            <div className="hero-stars">
              <span>✦</span>
              <span>✦</span>
              <span>✦</span>
            </div>
            <p className="hero-description">
              Every gemstone and Rudraksha offered by Astro Logical Solutions is
              a natural and carefully handcrafted product. This policy clearly
              outlines the conditions under which you may request a return,
              exchange, or cancellation, along with the applicable refund
              process and timelines. Our aim is to keep the policy simple,
              transparent, and easy to understand, while ensuring it is aligned
              with the applicable provisions of the Consumer Protection Act,
              2019.
            </p>
            <div className="shipping-points">
              <span>7-Day Return Window</span>
              <span>100% Proven-Synthetic Refund</span>
              <span>Refund to Original Source</span>
              <span>Insured, Tracked Shipping</span>
            </div>
          </div>
        </section>
        <section className="shipping-details">
          <div className="content-section">
            <div className="section-heading">
              <h3>Policy at a Glance</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Here is the short version. Every point below is explained in full
              further down the page. If anything is unclear, message us on
              WhatsApp before you buy — we would rather answer a question than
              process a return.
            </p>

            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>7 Days to Raise It</h4>
                <p>
                  You may request a return, exchange, or refund within 7 days of
                  delivery if the product is received damaged, incorrect, or is
                  verified to be synthetic.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Proven-Synthetic = 100% Refund</h4>

                <p>
                  If a gemstone is verified as artificial by a
                  Government-recognised or ISO-certified gem laboratory, you may
                  choose between a full refund, return, or exchange, subject to
                  the applicable terms of this policy.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Unboxing Video Required</h4>

                <p>
                  A continuous and unedited unboxing video is required to verify
                  the condition of the product at the time of delivery and to
                  process any return, exchange, or refund claim.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Refund to Source Only</h4>

                <p>
                  All approved refunds will be credited to the original payment
                  method used for the purchase, in accordance with applicable
                  laws and regulations. Refunds will not be transferred to any
                  other account or payment method.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Clear Timelines</h4>

                <p>
                  Prepaid order refunds are generally processed within 5–7
                  working days. Other approved refunds may take 10–12 working
                  days.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Cancel Before Dispatch</h4>

                <p>
                  Changed your mind? You can cancel your order free of charge at
                  any time before it has been dispatched. Simply contact us via
                  WhatsApp to request the cancellation.
                </p>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Return & Exchange Eligibility</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Because each stone is natural and handcrafted, and because
              gemstones are unfortunately vulnerable to being swapped for fake
              or lower-quality counterparts, we accept returns and exchanges
              only under clearly defined conditions. Please read these before
              requesting a return.
            </p>

            <div className="page">
              <div className="policy-card">
                <h2>You are eligible for a return or exchange when:</h2>

                <ul>
                  <li>
                    <strong>The item arrived damaged</strong> during transit, or
                  </li>

                  <li>
                    <strong>You received an incorrect product</strong>{" "}
                    (different from what you ordered), or
                  </li>

                  <li>
                    <strong>
                      The Astro Logical Solutions is proven synthetic or
                      artificial
                    </strong>{" "}
                    by a Government gemological institute (ISO-certified or
                    internationally reputed) — see the guarantee below.
                  </li>
                </ul>

                <h2>Conditions that must be met:</h2>

                <ul>
                  <li>
                    <strong>Timeframe:</strong> The request must be made within
                    seven (07) days of receiving your product.
                  </li>

                  <li>
                    <strong>Original condition:</strong> The item must be
                    returned in its original condition with its original
                    certification and packaging intact. Any tampering with the
                    product or its certification is sufficient cause for us to
                    deny the request.
                  </li>

                  <li>
                    <strong>Unboxing video (mandatory):</strong> Due to the
                    nature of the products, the Company requires a continuous,
                    unedited videographic proof of unboxing to internally
                    evaluate the condition of the product and make an informed
                    decision. This video is a prerequisite for any return or
                    exchange — without it, the Company is unable to process the
                    request and no further action will be taken.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>The 100% Proven-Synthetic Guarantee</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              This is the promise we are proudest of. We take utmost pride in
              serving only genuine, natural stones — and we back it in writing.
            </p>

            <div className="page">
              <div className="policy-card">
                <ul>
                  <li>
                    If you have any concerns regarding the authenticity of your
                    gemstone, you may have it independently examined by a
                    Government gemological institute, ISO-certified laboratory,
                    or other internationally recognized gemological authority.
                    If the gemstone is officially determined to be synthetic or
                    artificial by such an institution, Astro Logical Solutions
                    will provide you with a 100% refund, return, or exchange, as
                    per your preference.
                    <br />
                    Every order from Astro Logical Solutions is accompanied by a
                    verifiable Authenticity Certificate, allowing you to verify
                    the certificate details using its unique number whenever
                    required. For more information about our authenticity
                    commitment and guarantee, please visit our Certification &
                    Guarantee page or use our Check Certificate option to verify
                    your certificate.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Items That Cannot Be Returned</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Non-Returnable & Non-Exchangeable Categories: Certain gemstone
              products are not eligible for return or exchange unless they are
              received damaged or incorrectly supplied. This policy is designed
              to safeguard both our customers and Astro Logical Solutions,
              particularly for gemstones that are customized to individual
              specifications or require strict authenticity controls after
              leaving our custody.
            </p>
            <div className="timeline-table-wrapper">
              <table className="timeline-table">
                <thead>
                  <tr>
                    <th>
                      Not eligible for return/exchange (unless damaged or
                      incorrect)
                    </th>
                    <th>Why</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>
                        Customised / made-to-order & engraved jewellery
                      </strong>
                    </td>
                    <td>
                      {" "}
                      Manufactured to your approved design and fitting size;
                      cannot be resold.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>
                        Personalised rings, lockets, pendants, bracelets &
                        necklaces (made to a specific fitting/size)
                      </strong>
                    </td>
                    <td>Made specifically for you.</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Bead bracelets & malas</strong>
                    </td>
                    <td>
                      Intimate-wear items easily swapped with counterfeits.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Crystal trees</strong>
                    </td>
                    <td>Fragile, handcrafted decorative pieces.</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Sale / discounted items</strong>
                    </td>
                    <td>
                      Generally final sale for change-of-mind (statutory rights
                      below still apply).
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Products received exactly as ordered</strong>
                    </td>
                    <td>No defect — delivered as described.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="content-section order-tracking-section">
            <div className="section-heading">
              <h3>What is not a valid reason for return</h3>
              <br />
              <div className="heading-line"></div>
            </div>

            <p>
              1. Change of mind: simply disliking the product or no longer
              wishing to keep it.
            </p>
            <br />

            <p>
              {" "}
              2.Minor flaws or packaging issues that do not affect the quality
              or function of the product.
            </p>
            <br />

            <p>
              3. Slight colour or size variation from what was perceived on
              screen — natural stones vary, and lighting, screen resolution and
              manufacturing tolerances cause small differences.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Refund Methods & Timelines</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              After we receive and review your returned item, we will email you
              to confirm its receipt and inform you whether your refund has been
              approved or declined. If approved, the refund will always be
              issued to the <b>original / source method of payment </b> . This
              is required for legal and compliance purposes and helps prevent
              any penalties or issues arising from payments being sent to an
              incorrect source.
            </p>
            <div className="timeline-table-wrapper">
              <table className="timeline-table">
                <thead>
                  <tr>
                    <th>Payment method</th>
                    <th>Refund destination</th>
                    <th>Timeline (after approval)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>
                        Prepaid — Credit Card / Debit Card / Net Banking / UPI
                      </strong>
                    </td>
                    <td> Original account / card</td>

                    <td>5–7 working days</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Other approved refunds</strong>
                    </td>
                    <td>Original payment source</td>
                    <td>10–12 working days</td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Cash on Delivery (COD)</strong>
                    </td>
                    <td>
                      Bank account you provide (name must match the order)
                    </td>
                    <td>10–12 working days</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Who Pays for Return Shipping</h3>
              <div className="heading-line"></div>
            </div>
            <p>The answer depends on why the item is coming back:</p>

            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Our mistake</h4>
                <p>
                  If you received a damaged or incorrect item, we will assist
                  you with the return process, and you will not be responsible
                  for any costs caused by our mistake.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Verification returns</h4>

                <p>
                  For approved returns and exchanges, courier charges, as well
                  as any GST or duties already paid, are non-refundable. The
                  Company does not provide return pickup services. You are
                  responsible for arranging and paying the return shipping
                  costs, which are not eligible for reimbursement or issuance as
                  a credit note.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Return address</h4>

                <p>
                  All approved return items must be sent to our designated
                  returns and operational office at: Shiva Aangan, Bachan Singh
                  Colony, Lane No.9, Muzaffarnagar, Uttar Pradesh, 251001.
                </p>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Cancelling Your Order</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We keep cancellation simple and fair — you are never locked in
              once you have paid.
            </p>

            <div className="page">
              <div className="policy-card">
                <ul>
                  <li>
                    Before Dispatch — Free Cancellation: You may cancel your
                    order at no additional cost before it has been dispatched.
                    Please contact us via <b>WhatsApp</b> as soon as possible so
                    we can process the cancellation before shipment. Any
                    eligible refund will be issued to the original payment
                    method.
                  </li>

                  <li>
                    <b>After Dispatch:</b> Once your order has been dispatched
                    from our facility, it will be subject to the return
                    conditions outlined above. Where eligible, you may refuse
                    delivery or submit a return request within the applicable
                    7-day return period.
                  </li>
                  <li>
                    <b>Customised / Made-to-Order Items:</b> Customised items
                    are produced only after you have reviewed and approved the
                    final design, whether provided in CAD or another format.
                    Once the design has been approved and production has
                    started, any making charges already incurred are
                    non-refundable and will be deducted from the advance payment
                    received. Any remaining eligible balance will be refunded in
                    accordance with this policy. Such deductions will be limited
                    to the actual costs incurred in producing the customised
                    item.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Damaged, Defective or Wrong Item Received</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              If your order arrives damaged, defective or is not the item you
              ordered, we will make it right. We replace items that are
              defective or damaged on receipt.
            </p>

            <div className="page">
              <div className="policy-card">
                <ul>
                  <li>
                    Do not discard the packaging. Keep the box, filler and
                    certificate exactly as received.
                  </li>

                  <li>
                    Share your unboxing video and clear photos of the issue
                    within 7 days of delivery.
                  </li>
                  <li>
                    Email <b>support@astrologicalsolutions.in</b> (or WhatsApp
                    us) with your order number and the evidence.
                  </li>
                  <li>
                    We review and respond, then arrange a replacement of the
                    same item (subject to availability) or a refund. All
                    returned items must reach us in original condition with
                    packaging and tags where applicable.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>How to Raise a Request & Grievance Redressal</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We aim to resolve every concern quickly and courteously. Reach us
              through any channel below — WhatsApp is the fastest.
            </p>

            <div className="shipping-info-cards">
             
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Email</h4>
                <p>support@astrologicalsolutions.in</p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>WhatsApp</h4>
                <p>+91 7351739191</p>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>Late or Missing Refunds</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              If your refund has been approved but you have not received it yet,
              please follow these steps before contacting us:
            </p>

            <div className="page">
              <div className="policy-card">
                <ul>
                  <li>
                    Re-check your bank account or card statement for the
                    transaction.
                  </li>

                  <li>
                    Contact your credit/debit card company — posting a refund
                    can take extra time on their side.
                  </li>
                  <li>
                    Contact your bank, as refund processing involves several
                    steps and can take time to reflect.
                  </li>
                  <li>
                    If you have completed all of the above and still have not
                    received your refund, please contact us at{" "}
                    <b>support@astrologicalsolutions.in</b> and we will help
                    track it down.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <section className="delivery-section">
            <div className="delivery-content">
              <h2>Still Have a Question?</h2>
              <p>
                Our team is here Monday to Saturday, 10am–7pm IST. Message us on
                WhatsApp for the fastest <br />
                help with any return, refund or cancellation.
              </p>
                <div className="delivery-buttons">
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Chat on WhatsApp
                </a>
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Visit Help Center
                </a>
              </div>
            </div>
          </section>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Refund;
